import { useFieldsStyles } from 'assets/styles/common';
import { ShowRecordButton } from 'components';
import { FC } from 'react';
import { Datagrid, DateField, List, ListProps, NumberField, TextField, TextInput } from 'react-admin';
import { ResourceName } from 'types/resources';

const SearchInput = (
  <TextInput key="filter" source={`${ResourceName.NUTRITION_PLANS}.filter`} label="Search" alwaysOn />
);

export const NutritionPlansList: FC<ListProps> = (props) => {
  const { textField, richTextField, numberField } = useFieldsStyles();
  return (
    <List {...props} filters={[SearchInput]} bulkActionButtons={false}>
      <Datagrid>
        <NumberField source="id" sortable={false} className={numberField} />
        <DateField source="createdAt" sortable={false} />
        <TextField source="title" className={textField} sortable={false} />
        <TextField source="description" className={richTextField} sortable={false} />
        <ShowRecordButton />
      </Datagrid>
    </List>
  );
};
